<template>
  <div>
    <ylNewsHomeMobile v-if="isMobileScreen" v-bind="$attrs" />
    <ylNewsHomePC v-else v-bind="$attrs" />
  </div>
</template>
<script>
export default {
  name: "ylNewsHome",
  components: {
    ylNewsHomeMobile: () => import("./components/mobile.vue"),
    ylNewsHomePC: () => import("./components/pc.vue"),
  },
  data() {
    return {};
  },
  computed: {
    screenWidth() {
      return this.$store.getters.screenWidth;
    },
    screenHeight() {
      return this.$store.getters.screenHeight;
    },
    isMobileScreen() {
      return this.$store.getters.isMobileScreen;
    },
  },
  created() { },
  methods: {},
};
</script>